import axios from 'axios';

const API_KEY = "AIzaSyDmncAyxuP66xJr9-nWbr0gG8j6YN8Ks0Q";
const BASE_URL = 'https://www.googleapis.com/youtube/v3';

// Search for channels (artists)
export const searchChannels = async (query, maxResults = 10) => {
  try {
    const response = await axios.get(`${BASE_URL}/search`, {
      params: {
        part: 'snippet',
        q: query,
        type: 'channel',
        maxResults: maxResults,
        key: API_KEY
      }
    });
    return response.data.items.map(item => ({
      id: item.id.channelId,
      name: item.snippet.title,
      image: item.snippet.thumbnails.high.url,
      description: item.snippet.description,
      gradient: 'from-red-500 to-pink-500' // YouTube red
    }));
  } catch (error) {
    console.error('Error searching YouTube channels:', error);
    return [];
  }
};

// Get videos by channel ID
export const getChannelVideos = async (channelId, maxResults = 10) => {
  try {
    const response = await axios.get(`${BASE_URL}/search`, {
      params: {
        part: 'snippet',
        channelId: channelId,
        maxResults: maxResults,
        order: 'relevance',
        type: 'video',
        key: API_KEY
      }
    });
    return response.data.items.map(item => ({
      id: item.id.videoId,
      title: item.snippet.title,
      album: 'YouTube',
      singer: item.snippet.channelTitle,
      videoId: item.id.videoId,
      artwork_url: item.snippet.thumbnails.high.url,
      duration: 0, // YouTube doesn't provide duration in search
      permalink_url: `https://www.youtube.com/watch?v=${item.id.videoId}`
    }));
  } catch (error) {
    console.error('Error fetching channel videos:', error);
    return [];
  }
};

// Search videos by query (for songs)
export const searchVideos = async (query, maxResults = 10) => {
  try {
    const response = await axios.get(`${BASE_URL}/search`, {
      params: {
        part: 'snippet',
        q: query,
        maxResults: maxResults,
        type: 'video',
        key: API_KEY
      }
    });
    return response.data.items.map(item => ({
      id: item.id.videoId,
      title: item.snippet.title,
      album: 'YouTube',
      singer: item.snippet.channelTitle,
      videoId: item.id.videoId,
      artwork_url: item.snippet.thumbnails.high.url,
      duration: 0,
      permalink_url: `https://www.youtube.com/watch?v=${item.id.videoId}`
    }));
  } catch (error) {
    console.error('Error searching YouTube videos:', error);
    return [];
  }
};